var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGoodAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm4.76-13l-6.172 5.68-2.366-2.137L4 9.72 7.551 13h.015L15 6.152 13.76 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoodAnswer);
export default __webpack_public_path__ + "static/media/ic-good-answer.240739d5310f7952f57e48e17937c006.svg";
export { ForwardRef as ReactComponent };